import { extractNumbers } from '@/utils/extract-numbers';

/**
 * Valida se um CPF é válido
 * @param cpf - CPF a ser validado (pode conter pontos e hífen)
 * @returns true se o CPF for válido, false caso contrário
 * @example
 * isValidCPF('123.456.789-01') // true ou false dependendo da validade
 * isValidCPF('12345678901') // true ou false dependendo da validade
 * isValidCPF('111.111.111-11') // false (dígitos repetidos)
 */
export const isValidCPF = (cpf: string): boolean => {
  const cleanCPF = extractNumbers(cpf);

  if (cleanCPF.length !== 11) return false;

  const repeatedDigitsRegex = /^(\d)\1{10}$/;
  if (repeatedDigitsRegex.test(cleanCPF)) return false;

  // Valida os dígitos verificadores
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (10 - i);
  }
  let remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCPF.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleanCPF.charAt(i)) * (11 - i);
  }
  remainder = 11 - (sum % 11);
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cleanCPF.charAt(10))) return false;

  return true;
};
